export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 44 44" className={className} aria-hidden="true">
    <rect x="16" y="2" width="24" height="14" fill="#55453E" />
    <rect
      x="2"
      y="15"
      width="24"
      height="14"
      fill="#A77C5A"
      transform="rotate(-4 14 22)"
    />
    <rect x="14" y="28" width="24" height="14" fill="#55453E" />
  </svg>
);

export const Logo = ({ inverse = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-9 w-9 shrink-0" />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display text-xl font-semibold tracking-[0.28em] ${
          inverse ? "text-white" : "text-cafe-dark"
        }`}
      >
        OESCA
      </span>
      <span
        className={`mt-1 font-mono text-[9px] font-medium uppercase tracking-[0.42em] ${
          inverse ? "text-cafe" : "text-cafe-muted"
        }`}
      >
        Construcciones
      </span>
    </span>
  </span>
);
